// Trạng thái dùng chung giữa các trang: người dùng đăng nhập, cache bot (cập nhật từ WS bot.changed), bot đã tick.
import { api } from "./api";
import type { Bot, JobSpec, RunSummary, User } from "./types";
import { runAlive } from "./format";
import { soSanhTenBot } from "./logic-bot-duyet";

export const store = {
  user: null as User | null,
  bots: new Map<string, Bot>(),
  botsLoadedAt: 0,
  ticked: new Set<string>(),
  // Gói H: spec AI soạn từ lệnh chữ, chờ form job (#/jobs/new) nhận để "Sửa trong form"; form đọc xong thì xoá.
  draftSpec: null as JobSpec | null,
  // V3: số câu chờ duyệt do trang Chờ duyệt vừa đếm (dùng cho huy hiệu menu khi danh sách bot chưa tải); null = chưa biết.
  choDuyetN: null as number | null,
  // N11 (05/10/2026): Chế độ kỹ thuật — CHỈ Super bật được (Cài đặt); bật thì hiện nhóm menu "Kỹ thuật" và các địa chỉ cũ (#/jobs/new, #/lenh,
  // #/bundles, #/jobs) mở trang cũ thay vì chuyển sang Kịch bản. Lưu trên trình duyệt (localStorage boss.kyThuat.<userId>) — tiện ích giao
  // diện, KHÔNG phải ranh giới quyền (API vẫn như cũ, quyền thật ở policy máy chủ).
  kyThuat: false,
};

/** Khoá localStorage của Chế độ kỹ thuật cho một tài khoản. */
export const khoaKyThuat = (userId: string): string => `boss.kyThuat.${userId}`;

/** Đọc Chế độ kỹ thuật: chỉ Super; localStorage hỏng / bị chặn / giá trị lạ → tắt (trang vẫn chạy). */
export function docKyThuat(u: User | null): boolean {
  if (!u || u.role !== "super") return false;
  try { return localStorage.getItem(khoaKyThuat(u.id)) === "1"; } catch { return false; }
}

/** Bật/tắt Chế độ kỹ thuật cho người đang đăng nhập. Trả trạng thái SAU khi đặt: lưu lỗi (trình duyệt chặn) → tắt. */
export function datKyThuat(on: boolean): boolean {
  const u = store.user;
  if (!u || u.role !== "super") { store.kyThuat = false; return false; }
  try {
    if (on) localStorage.setItem(khoaKyThuat(u.id), "1"); else localStorage.removeItem(khoaKyThuat(u.id));
    store.kyThuat = on;
  } catch { store.kyThuat = false; }
  return store.kyThuat;
}

/** Lần chạy đổi (WS run.changed) → cập nhật "đang làm gì" của bot trong bộ nhớ chung (thẻ bot, huy hiệu menu, nút DỪNG TẤT CẢ). */
export function apDungRun(r: RunSummary): void {
  const b = store.bots.get(r.botId);
  if (!b) return;
  if (runAlive(r.status) && r.status !== "cho_gian_cach" && r.status !== "cho_den_luot") b.current = { runKey: r.key, bundleName: r.bundleName, status: r.status, stepId: r.pending?.stepId ?? b.current?.stepId };
  else if (b.current?.runKey === r.key) delete b.current;
}

export function isSuper(): boolean {
  return store.user?.role === "super";
}

/** Lấy danh sách bot (cache 5 s trừ khi force). */
export async function loadBots(force = false): Promise<Bot[]> {
  if (!force && store.botsLoadedAt && Date.now() - store.botsLoadedAt < 5_000) return [...store.bots.values()];
  const list = await api<Bot[]>("GET", "/api/bots");
  store.bots.clear();
  for (const b of list) store.bots.set(b.id, b);
  store.botsLoadedAt = Date.now();
  // Bỏ tick bot không còn.
  for (const id of [...store.ticked]) if (!store.bots.has(id)) store.ticked.delete(id);
  return list;
}

export function upsertBot(b: Bot): void {
  store.bots.set(b.id, b);
}

export function botName(id: string): string {
  return store.bots.get(id)?.name ?? id;
}

/** Sắp xếp: chờ duyệt → đang chạy → online rảnh → offline; cùng nhóm theo tên TỰ NHIÊN ("Máy 2" trước "Máy 10" — L1 rà soát 05/10). */
export function sortBots(list: Bot[]): Bot[] {
  const rank = (b: Bot): number => {
    if (b.current?.status === "paused_approval" || b.current?.status === "paused_otp") return 0;
    if (!b.online) return 3;
    if (b.current) return 1;
    return 2;
  };
  return [...list].sort((a, b) => rank(a) - rank(b) || soSanhTenBot(a.name, b.name));
}
